import { ServiceBase, IBaseEntity } from './ServiceBase';
import { get } from '../ReaderlyHttpClient';

export interface Tag extends IBaseEntity {
}

export class TagsService extends ServiceBase<Tag> {
  constructor() {
    super('tags');
  }

  async GetFiltered(searchString?: string | undefined, itemsNumber?: number) {
    const params: Record<string, string> = {};
    params.searchString = searchString ?? "";
    params.count = `${itemsNumber ?? 7}`;

    return await get<Tag[]>('tags/filters', { params });
  }
}

const tagsServiceInstance = new TagsService();

export default tagsServiceInstance;
